module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "darylne-nemeth.588997f0.jpg" + "?" + Date.now();